import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';

import { IDisplayDepartmentDTO } from 'src/api/dtos';
import { IError } from 'src/api/types';

import { fetchDepartments } from './departments.actions';
import { IDepartmentsState } from './departments.types';

const initialState: IDepartmentsState = {
  data: [],
  loading: false,
  error: null,
};

export const departmentsSlice = createSlice({
  name: 'departments',
  initialState,
  reducers: {},
  extraReducers: (build) => {
    /* fetchDepartments */
    build.addCase(
      fetchDepartments.fulfilled.type,
      (state: Draft<IDepartmentsState>, { payload }: PayloadAction<IDisplayDepartmentDTO[]>) => {
        return {
          ...state,
          data: payload,
          loading: false,
        };
      },
    );
    build.addCase(fetchDepartments.pending.type, (state: Draft<IDepartmentsState>) => {
      return {
        ...state,
        error: null,
        loading: true,
      };
    });
    build.addCase(
      fetchDepartments.rejected.type,
      (state: Draft<IDepartmentsState>, { payload }: PayloadAction<IError>) => {
        return {
          ...state,
          error: payload,
          loading: false,
        };
      },
    );
  },
});
